import { EnumValueType } from './Generated';
import { fromBase64, toBase64 } from 'js-base64';

export interface IApiValued {
    value: string;
    type: EnumValueType;
}

export function encodeValue<T extends IApiValued>(setting: T): T {
    if (setting.type === EnumValueType.Html || setting.type === EnumValueType.Json) {
        return {
            ...setting,
            value: toBase64(setting.value),
        };
    }
    return { ...setting };
}

export function decodeValue<T extends IApiValued>(setting: T): T {
    if (setting.type === EnumValueType.Html || setting.type === EnumValueType.Json) {
        return {
            ...setting,
            value: fromBase64(setting.value),
        };
    }
    return { ...setting };
}
